// extracted by mini-css-extract-plugin
export default {"logsTable":"List_logsTable__MtsdO","messageCell":"List_messageCell__NrQSo","messagePreview":"List_messagePreview__ND0+R","copyButton":"List_copyButton__eG3th"};